export enum Cohort {
    Dtc = 'direct_to_consumer',
}

export const circleAuthorizationTokenHeaderKey = 'Circle-Authorization-Token';
